import React from "react";
import img1 from "../fotos/dog.jpg";
import "../files/dog1.css";

const Dog1 = () => {
  return (
    <>
      <div className="dog1-content">
        <div className="dog1-wrapper">
          <div className="dogname">Afador</div>
          <div className="img1">
            <img className="afd" src={img1}></img>
          </div>
          <div className="about-dog">
            <p>
              The Afador is a mixed breed dog–a cross between the Afghan Hound
              and Labrador Retriever dog breeds. Loyal, energetic, and
              affectionate, these pups inherited some of the best qualities from
              both of their parents. Afadors are also sometimes known as the
              Afghan Lab. You can find these mixed breed dogs in shelters and
              breed specific rescues, so remember to always adopt! Don’t shop if
              you’re looking to add an Afador to your home! Afadors make
              excellent family pets, although they do better with older children
              and seasoned dog owners who can give the breed the training and
              attention they require. Afadors also make for good guard dogs, and
              they’re alert to strangers. The mixed breed is very energetic and
              athletic, so access to a safe outdoor space is preferred. See
              below for all mixed dog breed traits and facts about Afadors!
            </p>
          </div>
          <div className="characterstics">
            <div className="heading"> Breed Characterstics :</div>
            <div className="adaptability-table">
              <div className="adpt-1">
                <div className="more-info-tag1"></div>
                Adapts well to apartment living
              </div>
              <div className="stars-block1">
                <div className="stars1">
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                </div>
              </div>
              <div className="adpt-2">
                <div className="more-info-tag2"></div>
                Good for Novice Owners
              </div>
              <div className="stars-block2">
                <div className="stars2">
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                </div>
              </div>
              <div className="adpt-3">
                <div className="more-info-tag3"></div>
                Sensitivity level
              </div>
              <div className="stars-block3">
                <div className="stars3">
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                </div>
              </div>
              <div className="adpt-4">
                <div className="more-info-tag4"></div>
                Tolerates being alone
              </div>
              <div className="stars-block4">
                <div className="stars4">
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                </div>
              </div>
              <div className="adpt-5">
                <div className="more-info-tag5"></div>
                Tolerates Cold weather
              </div>
              <div className="stars-block5">
                <div className="stars5">
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-gold.svg"
                  ></img>
                  <img
                    className="star"
                    src="https://dogtime.com/wp-content/themes/dogtime-2019/images/icons/icon-rating-star-grey.svg"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dog1;
